import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useUserRole } from '@/hooks/useUserRole';
import LoadingSpinner from '@/components/ui/LoadingSpinner';

const RoleBasedRedirect: React.FC = () => {
  const { user, isLoading: authLoading } = useAuth();
  const { userRole, isLoading: roleLoading } = useUserRole();

  // Show loading while determining role
  if (authLoading || roleLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Role-based dashboard redirection
  const getDashboardRoute = (): string => {
    switch (userRole) {
      case 'super_admin':
        return '/admin/dashboard';
      case 'school_admin':
        return '/schoolAdmin/dashboard';
      case 'teacher':
        return '/teacher/dashboard';
      case 'parent':
        return '/parent/dashboard';
      case 'driver':
        return '/driver/dashboard';
      case 'student':
        return '/student/dashboard';
      default:
        // Fallback based on role string if userRole detection fails
        const roleString = user.role?.toLowerCase() || '';
        if (roleString.includes('super') || roleString.includes('platform')) {
          return '/admin/dashboard';
        } else if (roleString.includes('school') || roleString.includes('admin')) {
          return '/schoolAdmin/dashboard';
        } else if (roleString.includes('teacher')) {
          return '/teacher/dashboard';
        } else if (roleString.includes('parent')) {
          return '/parent/dashboard';
        } else if (roleString.includes('driver')) {
          return '/driver/dashboard';
        } else if (roleString.includes('student')) {
          return '/student/dashboard';
        }
        // Final fallback
        return '/admin/dashboard';
    }
  };

  return <Navigate to={getDashboardRoute()} replace />;
};

export default RoleBasedRedirect;